var _rect, _g, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDownloadDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.5 54.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 198,
    height: 53,
    fill: "#fff",
    className: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "shade1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.35,33.95v-10.2h-3.9v-2.7h11v2.7h-3.9v10.2h-3.2Z",
    fill: "#73a857",
    className: "needfill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.05,29.35c0-1.4,.4-2.5,1.3-3.5s2-1.4,3.5-1.4c1.3,0,2.4,.4,3.1,1.3,.8,.8,1.1,1.9,1.1,3.2l-.1,1h-5.9c.1,.5,.4,1,.8,1.2,.4,.3,.9,.4,1.4,.4,.4,0,.8-.1,1.2-.2,.4-.2,.8-.3,1-.5l.3-.2,1.2,2.2c-.1,.1-.3,.2-.5,.4-.2,.1-.7,.4-1.4,.6s-1.4,.4-2.1,.4c-1.6,0-2.8-.5-3.7-1.4-.7-1-1.2-2.3-1.2-3.5Zm3.2-1.3h2.7c0-.4-.1-.7-.3-.9-.2-.3-.5-.4-.9-.4-.7,.1-1.2,.6-1.5,1.3Zm.3-4.2l1.5-2.7h3.1l-2.1,2.7h-2.5Z",
    fill: "#73a857",
    className: "needfill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.75,30.45v-9.4h3.1v9c0,.5,.1,.8,.2,.9,.1,.2,.3,.3,.7,.3h.4v2.7c-.3,0-.6,.1-.9,.1-.5,0-.9,0-1.3-.1s-.7-.2-1.1-.5c-.4-.2-.6-.6-.8-1.1-.3-.5-.3-1-.3-1.9Z",
    fill: "#73a857",
    className: "needfill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.05,29.35c0-1.4,.4-2.5,1.3-3.5s2-1.4,3.5-1.4c1.3,0,2.4,.4,3.1,1.3,.8,.8,1.1,1.9,1.1,3.2l-.1,1h-5.9c.1,.5,.4,1,.8,1.2,.4,.3,.9,.4,1.4,.4,.4,0,.8-.1,1.2-.2,.4-.2,.8-.3,1-.5l.3-.2,1.2,2.2c-.1,.1-.3,.2-.5,.4-.2,.1-.7,.4-1.4,.6s-1.4,.4-2.1,.4c-1.6,0-2.8-.5-3.7-1.4-.9-1-1.2-2.3-1.2-3.5Zm3.1-1.3h2.7c0-.4-.1-.7-.3-.9-.2-.3-.5-.4-.9-.4-.6,.1-1.1,.6-1.5,1.3Zm.2-4.2l1.5-2.7h3.1l-2.1,2.7h-2.5Z",
    fill: "#73a857",
    className: "needfill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.15,29.35c0-1.3,.5-2.5,1.4-3.4,.9-1,2.2-1.4,3.8-1.4,.5,0,.9,0,1.3,.1s.8,.2,1.1,.4c.3,.1,.5,.3,.7,.4s.3,.3,.4,.4l.1,.1-1.3,2.1-.3-.3c-.1-.1-.4-.2-.7-.4s-.8-.3-1.1-.3c-.7,0-1.2,.2-1.6,.7-.4,.4-.6,1-.6,1.6s.2,1.1,.6,1.6,1,.7,1.7,.7c.4,0,.8-.1,1.2-.3l1-.5,.3-.3,1.1,2.2-.2,.2c-.1,.1-.2,.2-.5,.4s-.5,.3-.8,.5c-.3,.1-.7,.3-1.1,.4-.5,.1-.9,.2-1.4,.2-1.6,0-2.8-.5-3.8-1.4-.8-1.2-1.3-2.3-1.3-3.7Z",
    fill: "#73a857",
    className: "needfill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.65,33.95v-12.9h3.1v4.9h0c.3-.5,.6-.8,1.2-1.1s1.1-.4,1.7-.4c2.2,0,3.3,1.2,3.3,3.5v6h-3.1v-5.4c0-.8-.3-1.2-1-1.2-.9,0-1.6,.5-1.9,1.4-.1,.3-.2,.7-.2,1.2v4.1h-3.1v-.1Z",
    fill: "#73a857",
    className: "needfill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.35,31.15c0-.6,.2-1.2,.6-1.6s.9-.8,1.6-.9c.6-.2,1.2-.3,1.7-.4s1-.1,1.5-.1h.2v-.2c0-.7-.5-1-1.4-1-.3,0-.7,.1-1.1,.2-.4,.2-.7,.3-1,.4l-.4,.2-1.1-2.2c.1-.1,.3-.2,.5-.3,.2-.1,.7-.3,1.4-.5,.7-.2,1.4-.3,2-.3,1.3,0,2.3,.3,3.1,1,.7,.7,1.1,1.6,1.1,2.8v5.7h-2.8v-1.2h0l-.1,.2c0,.1-.1,.2-.3,.3s-.3,.3-.5,.4-.4,.2-.7,.3h-1c-.9,0-1.6-.3-2.2-.8s-1.1-1.1-1.1-2Zm3.3-.2c0,.2,.1,.4,.2,.6,.1,.1,.4,.2,.7,.2,.4,0,.8-.2,1.1-.5,.3-.3,.5-.7,.5-1.1v-.2h-.3c-.6,0-1.1,.1-1.5,.3-.6,.1-.7,.5-.7,.7Z",
    fill: "#73a857",
    className: "needfill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.15,33.95v-9.3h3v2.3h0c.2-.6,.6-1.2,1.1-1.6s1.2-.7,1.8-.7h.4v3.1c-.2,0-.4-.1-.6-.1-1.2,0-2,.5-2.4,1.6-.1,.3-.2,.8-.2,1.3v3.4h-3.1Z",
    fill: "#73a857",
    className: "needfill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.15,34.45c.8,.4,1.6,.6,2.6,.6,1.4,0,2.1-.6,2.1-1.8v-.5h0c-.5,.6-1.3,1-2.3,1-1.3,0-2.3-.5-3.1-1.4-.7-.9-1.1-2-1.1-3.3s.4-2.3,1.1-3.2,1.7-1.3,3.1-1.3c.5,0,1,.1,1.4,.2s.7,.3,.9,.4l.3,.2h.1v-.7h2.9v8.4c0,.8-.1,1.5-.4,2.1s-.7,1.1-1.2,1.4c-.5,.4-1.1,.6-1.7,.8s-1.2,.3-1.9,.3c-1.3,0-2.5-.3-3.5-.8l.7-2.4Zm3.1-3.4c.5,0,.9-.2,1.2-.5,.3-.3,.5-.8,.5-1.6,0-1.3-.6-2-1.8-2-.5,0-.9,.2-1.2,.5s-.4,.8-.4,1.3c0,.6,.2,1.1,.5,1.6s.6,.7,1.2,.7Z",
    fill: "#73a857",
    className: "needfill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.65,29.35c0-1.4,.4-2.5,1.3-3.5s2-1.4,3.5-1.4c1.3,0,2.4,.4,3.1,1.3,.8,.8,1.1,1.9,1.1,3.2l-.1,1h-5.9c.1,.5,.4,1,.8,1.2,.4,.3,.9,.4,1.4,.4,.4,0,.8-.1,1.2-.2,.4-.2,.8-.3,1-.5l.3-.2,1.2,2.2c-.1,.1-.3,.2-.5,.4-.2,.1-.7,.4-1.4,.6-.7,.3-1.4,.4-2.1,.4-1.6,0-2.8-.5-3.7-1.4-.7-1-1.2-2.3-1.2-3.5Zm3.2-1.3h2.7c0-.4-.1-.7-.3-.9s-.5-.4-.9-.4c-.7,.1-1.2,.6-1.5,1.3Z",
    fill: "#73a857",
    className: "needfill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.35,33.95v-9.3h3v2.3h0c.2-.6,.6-1.2,1.1-1.6s1.2-.7,1.8-.7h.4v3.1c-.2,0-.4-.1-.6-.1-1.2,0-2,.5-2.4,1.6-.1,.3-.2,.8-.2,1.3v3.4h-3.1Z",
    fill: "#73a857",
    className: "needfill"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 198,
    height: 53,
    fill: "none",
    stroke: "#73a857",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.15,40.95h-23c-.5,0-.9-.4-.9-.9s.4-.9,.9-.9h23c.5,0,.9,.4,.9,.9s-.4,.9-.9,.9Zm-11.5-5.6c-.2,0-.4-.1-.6-.3l-7.2-7.2c-.3-.3-.3-.9,0-1.2s.9-.3,1.2,0l5.7,5.7V14.35c0-.5,.4-.9,.9-.9s.9,.4,.9,.9v18l5.7-5.7c.3-.3,.9-.3,1.2,0s.3,.9,0,1.2l-7.2,7.2h0c-.2,.1-.5,.3-.6,.3Z",
    fill: "#73a857",
    className: "shade1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadDown);
export default __webpack_public_path__ + "static/media/ic_download_down.d2df26de07571ed5cea4848ba21036bc.svg";
export { ForwardRef as ReactComponent };